import slider from "./slider-con-flechas";
var proyectos = function () { return slider(); };
export default proyectos;
